import { Component } from '@angular/core';
import { ConfigurationService } from './services/configuration.service';
import { Config } from './Model/configurationModel';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent {
  smtpForm!:FormGroup;
  errorMessage!: string;
  isError!:boolean;
  isEdit = false;
  configDetail !: any;
  configSubscription !: Subscription;
  
  constructor(private readonly configService:ConfigurationService, private readonly fb:FormBuilder){}

  getConfig(){

    this.smtpForm = this.fb.group({
      smtpHost: [{value:'', disabled: !this.isEdit}],
      smtpPort: [{value:'', disabled: !this.isEdit}],
      timeOut: [{value:'', disabled: !this.isEdit}],
      secureSocketOptions: [{value:'', disabled: !this.isEdit}],
      fromAddress: [{value:'', disabled: !this.isEdit}],
      accountName: [{value:'', disabled: !this.isEdit}],
      password: [{value:'', disabled: !this.isEdit}],
      domain: [{value:'', disabled: !this.isEdit}],
      applicationBaseURL: [{value:'', disabled: !this.isEdit}],
      errorRecipient: [{value:'', disabled: !this.isEdit}],
      isActive: [{value:'', disabled: !this.isEdit}],
    })
    this.configSubscription= this.configService.GetSmtpConfiguration().subscribe({
      next: (Response:Config) =>{
        console.log(Response);
        this.configDetail = Response;
        this.smtpForm.patchValue(Response);
      },
      error: (error) => {console.log(error); this.isError=true;}
    });
  }

  ngOnInit() : void{
    this.getConfig();
  }

  ngOnDestroy() : void{
    this.configSubscription?.unsubscribe();
  }

  toggleEdit():void{
    this.isEdit = !this.isEdit;
  }

  onsubmit():void{

    const updateSmtpConfiguration = {
      ...this.smtpForm.value,
      Id: 2,
      timestamp: "AAAAAAAAB9I="
    };
      this.configService.updateSmtpConfiguration(updateSmtpConfiguration).subscribe(res => {
        alert("configuration done successfully");
        this.isEdit = false;
        this.getConfig();
      })
  }
}
